module.exports = __webpack_public_path__ + "static/img/news_24.9d9ab3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_24.jpg
// module id = omuq
// module chunks = 2